import React from "react";

import SubHeaderTabs from "views/components/SubHeaderTabs";

import { tabs as tabList } from "./tabs";

import style from "../style.module.css";

export const SubscriptionsPageSubHeaderTabs = () => {
  const tabs = tabList();

  return (
    <React.Fragment>
      <div className={style.headerPadding} />
      <SubHeaderTabs tabs={tabs} />
    </React.Fragment>
  );
};
